import { render } from "./PopupThanhToanQrCode.vue?vue&type=template&id=4fa0fceb"
import script from "./PopupThanhToanQrCode.vue?vue&type=script&lang=js"
export * from "./PopupThanhToanQrCode.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__